<template>
  <div>
    <v-list-tile v-if="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-list-tile>
    <v-list-tile v-else avatar @click="showProducts()">
      <v-list-tile-avatar>
        <v-icon v-if="rayon.subs" class="primary white--text">collections_bookmark</v-icon>
        <v-icon v-else class="primary white--text">book</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ rayon.title }}</v-list-tile-title>
        <v-list-tile-sub-title>
          <!-- Si pas sous-rayon -->
          <span v-if="rayon.subs">
            {{ $tc('subRayons', rayon.subs.length, { count: rayon.subs.length }) }} ;
          </span>
          <span v-if="rayon.products.length > 0">
            {{ $tc('products', rayon.products.length, { count: rayon.products.length }) }}
          </span>  
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action v-if="rayon.id != 0">
        <v-menu bottom left>
          <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="openDialogUpdate()">
              <v-list-tile-action>
                <v-icon>edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('edit') | cap }} {{ $tc(rayon.subs ? 'rayons' : 'subRayons', 1, { count: '' }) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogDelete()">
              <v-list-tile-action>
                <v-icon>delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('delete') | cap }} {{ $tc(rayon.subs ? 'rayons' : 'subRayons', 1, { count: '' }) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>

    <!-- DIALOGUES -->
    <v-dialog v-model="showDialogUpdate" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc(rayon.subs ? 'rayons' : 'subRayons', 1, { count: '' }) }}</v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              :label="$t('edit') + ' ' + $tc('subRayons', 1, { count: '' }) | cap" 
              v-model="rayonDialog.title"
              max="32" 
              required
              data-vv-name="rayonInput"
              v-validate="'required|max:32'" 
              :error="wzErrors.has('rayonInput')"
              :errors="wzErrors.collect('rayonInput')"
              @keyup.native.enter="submitDialogUpdate"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submit') }}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDelete" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc(rayon.subs ? 'rayons' : 'subRayons', 1, { count: '' }) }}?</v-card-title>
        <v-card-text>
          {{ $t('askRemoveLibrary') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogDelete = false">{{ $t('no') }}</v-btn>
          <v-btn color="primary" @click="submitDialogDelete()">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    rayon: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDelete: false,
      /**
       * indique si la vue affiche les phrases d'une rayon
       * @type {Boolean}
       */
      showSent: false,
      /**
       * rayon qui sera utilisé dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      rayonDialog: {},
      /**
       * loader
       */
      loading: false,
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false
    }
  },

  methods: {
    openDialogUpdate () {
      this.rayonDialog = _.clone(this.rayon)
      this.showDialogUpdate = true
    },
    openDialogDelete () {
      console.log(this.rayon)
      // propose la suppression de le rayon uniquement si elle ne contient pas de sous-rayon
      if (!this.rayon.subs || (this.rayon.subs && !this.rayon.subs.length)) {
        this.rayonDialog = _.clone(this.rayon)
        this.showDialogDelete = true
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Impossible à supprimer : contient ' + this.rayon.subs.length + ' ' + this.$tc('subRayons', this.rayon.subs.length, { count: this.rayon.subs.length }),
          context: 'warning'
        })
      }
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false
      // s'il y a bien eu une modification
      if ((this.rayon.title !== this.rayonDialog.title)) {
        // recherche de la rayon dans la liste des rayons
        // si elle n'est pas trouvée alors on peut la modifier
        let rayonFound = this.$store.getters['_Rayons/GET_RAYON_BY_TITLE'](this.rayonDialog.title)
        if (_.isNil(rayonFound)) {
          let dataToPost = new window.FormData()
          dataToPost.append('RAY_ID', this.rayonDialog.id)
          dataToPost.append('RAY_NAME', this.rayonDialog.title)
          this.loading = true
          this.axios.post('put/rayon.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(response => {
            // modification de la rayon dans la liste des rayons
            this.$store.commit('_Rayons/UPDATE_RAYON', this.rayonDialog)
            this.$emit('update:rayon', this.rayonDialog)
            this.$emit('update')
            // Notification
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          })
          .catch(_ => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
          })
          .then(_ => {
            this.loading = false
          })
        } else {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' })
        }
      }
    },
    submitDialogDelete () {
      this.showDialogDelete = false
      let dataToPost = new window.FormData()
      dataToPost.append('RAY_ID', this.rayon.id)
      this.loading = true
      this.axios.post('delete/rayon.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // succès
      .then(response => {
        // suppression de la rayon dans la liste des rayons
        this.$store.commit('_Rayons/REMOVE_RAYON', this.rayon)
        this.$emit('update:rayon', this.rayon)
        this.$emit('update')
        this.rayonDialog = {}
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
      })
      // erreur
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    showProducts () {
      // pour éviter de réaliser l'évenement si la souris est au-dessus du bouton de click
      if (!this.overMenu) {
        if (this.rayon.subs) {
          this.$router.push({ path: '/media/products/' + this.rayon.id })
        } else {
          this.$router.push({ path: '/media/products/' + this.rayon.sub + '/sub/' + this.rayon.id })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzRayon.vue